export default __webpack_public_path__ + "static/media/mailys.b5093afa.jpg";